import { DataClassName } from '@/Data/const'
import type { SchemaReferenceFilter } from '@/Data/types'

/**
 * Translates a schema `referenceFilter` into the filters to apply when searching
 * the resolved reference DataClass. Company and Person already encode `isPerson`
 * via the class itself, so it is stripped there; every other class (e.g. Contact)
 * keeps the full filter. Shared by the manual reference picker (`useAsyncSelect`)
 * and the chatbot's `search_entities` so both resolve a reference field to the
 * same sub-population — e.g. internal users only for an owner / `responsible`
 * field (`isExternal: false`), rather than every Person in the instance.
 */
export const getReferenceFilters = (
  className: string,
  referenceFilter?: SchemaReferenceFilter,
): Partial<SchemaReferenceFilter> => {
  if (!referenceFilter) {
    return {}
  }
  if (
    className === DataClassName.COMPANY ||
    className === DataClassName.PERSON
  ) {
    // do not use the Contact `isPerson` discriminator on Company or Person
    const { isPerson: _isPerson, ...rest } = referenceFilter
    return rest
  }
  return referenceFilter
}
